import { BrandMark } from '@/components/BrandMark';
import { cn } from '@/lib/utils';

// The logo lockups: Sweep mark + lowercase wordmark with a pine full stop,
// set in Syne 600. Horizontal is the default; stacked is for narrow or
// centered contexts (login). Sizes sit above the guidelines' minimums
// (horizontal 132px wide, stacked 84px).
//
// The mark carries no padding of its own, so spacing here is explicit:
// horizontal's gap-3 is the gap-2 it used to read as once the mark's dead box
// space is gone; stacked leans on the wordmark's own leading and takes none.
export function BrandLockup({
  variant = 'horizontal',
  className,
}: {
  variant?: 'horizontal' | 'stacked';
  className?: string;
}) {
  if (variant === 'stacked') {
    return (
      <span className={cn('inline-flex flex-col items-center', className)}>
        <BrandMark size="lg" />
        <span className="font-display text-3xl font-semibold tracking-[-0.01em]">
          valuegraph<span className="text-primary">.</span>
        </span>
      </span>
    );
  }
  return (
    <span className={cn('inline-flex items-center gap-3', className)}>
      <BrandMark size="sm" />
      <span className="font-display text-[18px] font-semibold tracking-[-0.01em]">
        valuegraph<span className="text-primary">.</span>
      </span>
    </span>
  );
}
